


















import { Vue, Component, Prop } from "vue-property-decorator";

import Title from "@/components/organisms/Modal//Title.vue";

@Component({ components: { Title } })
export default class Success extends Vue {}
